import {
  normalizer,
  get,
  getRequest,
  getWithMeta
} from 'helpers/RequestUtil'
import {
  select,
  fork,
  put,
  all,
  call,
  take,
  takeLatest,
  takeEvery,
  cancelled,
} from 'redux-saga/effects'
import {
  baseURL
} from 'config'

import {
  fetchReport as fetchReportAction,
  fetchQuerySource as fetchQuerySourceAction,
  fetchReportStart,
  fetchReportSuccess,
  fetchReportError,
  updateReport,
  removeReport,
  clearReports,
  resetQuery as resetQueryAction,
  clearFilter,
  fetchQuerySourceStart,
  fetchQuerySourceSuccess,
  fetchQuerySourceError,
  updateQuerySource,
  clearChartState,
  onSelectFilter
} from './actions'

import {
  MOUNT,
  FETCH_REPORT,
  ON_SELECT_FILTER,
  ON_UNSELECT_FILTER,
  FETCH_QUERY_SOURCE
} from './constants'
import {
  querySelector
} from './selectors'

import _ from 'lodash'

function* fetchReport(report, fetchType) {
  try {
    if (fetchType == 'query') yield put(fetchReportStart(report))
    yield put(clearChartState(report))
    const querySelection = yield select(querySelector())
    const product_ids = querySelection('sku')
    const data = yield call(getRequest, `${baseURL}/api/fulcrum/tool/nvqualoverview/${report}?product_ids=${product_ids}`)
    yield put(fetchReportSuccess(report))
    return data
  } catch (error) {
    yield put(fetchReportError(report, error))
  }
}

function* fetchQuerySource() {
  try {
    yield put(fetchQuerySourceStart())
    const data = yield call(getRequest, `${baseURL}/api/fulcrum/tool/nvqualoverview/query_source`)
    yield put(fetchQuerySourceSuccess())
    return data
  } catch (error) {
    yield put(fetchQuerySourceError(error))
  }
}

function* handleSelectFilter(action) {
  const { report, query } = action
  const data = yield call(fetchReport, report, 'filter')
  yield put(updateReport(data))
}

function* handleUnselectFilter(action) {
  const { report } = action
  yield put(removeReport(report))
}

function* handleFetchReport(action) {
  const { report } = action
  
  if (!report) return
  const data = yield call(fetchReport, report, 'query')
  yield put(updateReport(data))
}

function* handleFetchQuerySource() {
  const data = yield call(fetchQuerySource)
  yield all(data.map(src => put(updateQuerySource(src.type, src.source))))
}

function* handleMount() {
  yield put(resetQueryAction())
  yield put(clearReports())
  yield put(fetchQuerySourceAction())
}

function* watchFetchReport() {
  yield takeEvery(FETCH_REPORT, handleFetchReport)
}

function* watchSelectFilter() {
  yield takeEvery(ON_SELECT_FILTER, handleSelectFilter)
}

function* watchUnselectFilter() {
  yield takeEvery(ON_UNSELECT_FILTER, handleUnselectFilter)
}

function* watchFetchQuerySource() {
  yield takeEvery(FETCH_QUERY_SOURCE, handleFetchQuerySource)
}

function* watchMount() {
  yield takeEvery(MOUNT, handleMount)
}

function* loadSagas() {
  yield all([
    fork(watchFetchReport),
    fork(watchSelectFilter),
    fork(watchUnselectFilter),
    fork(watchFetchQuerySource)
  ])
}

export {
  watchMount
}

export default loadSagas